export default {
  get name(): string {
    return 'ExpoSecureStore';
  },
};
